/* Liya store theme: cart drawer, quick add, variants, gallery, menus, filters */
(function () {
  var d = document, b = d.body;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };

  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; }); });
  }

  /* re-render drawer + count badges from the server */
  function refreshCart(open) {
    return fetch(window.liya.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
      var html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      var fresh = html.querySelector('.drawer'), cur = $('.drawer');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      paintExtras();
      var n = fresh ? (fresh.querySelector('[data-cc2]') || {}).textContent || '0' : '0';
      $$('[data-cc]').forEach(function (e) { e.textContent = n; e.hidden = !+n; e.classList.remove('bump'); void e.offsetWidth; e.classList.add('bump'); });
      if (open) b.classList.add('cart-open');
      return fetch(window.liya.cartUrl + '.js').then(function (r) { return r.json(); });
    });
  }
  function notifyAdded(item, qty) {
    var box = $('[data-added]'); if (!box) return;
    var img = box.querySelector('[data-added-img]'), name = box.querySelector('[data-added-name]'), meta = box.querySelector('[data-added-meta]');
    var src = item && (item.featured_image && item.featured_image.url || item.image);
    img.innerHTML = '';
    if (src) { var i = d.createElement('img'); i.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2'); i.alt = ''; i.onerror = function () { i.src = src; }; img.appendChild(i); }
    name.textContent = (item && (item.product_title || item.title)) || 'Item';
    meta.textContent = 'Qty ' + (qty || 1);
    box.hidden = false; void box.offsetWidth; box.classList.add('show');
    clearTimeout(box._h); box._h = setTimeout(hideAdded, 5000);
  }
  function hideAdded() { var box = $('[data-added]'); if (!box) return; box.classList.remove('show'); setTimeout(function () { if (!box.classList.contains('show')) box.hidden = true; }, 250); }
  function addToCart(id, qty) {
    return post('/cart/add.js', { items: [{ id: +id, quantity: +qty || 1 }] }).then(function (res) {
      var item = res && res.items && res.items[0];
      return refreshCart(false).then(function () { notifyAdded(item, +qty || 1); return res; });
    });
  }

  /* global clicks */
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart],[data-cart-close],[data-menu],[data-search],[data-quick-add],[data-line-qty],[data-filters],[data-scrim],[data-added-close]');
    if (!t) return;
    if (t.hasAttribute('data-added-close')) { hideAdded(); }
    else if (t.hasAttribute('data-cart')) { e.preventDefault(); hideAdded(); b.classList.add('cart-open'); }
    else if (t.hasAttribute('data-cart-close') || t.hasAttribute('data-scrim')) b.classList.remove('cart-open', 'filters-open');
    else if (t.hasAttribute('data-menu')) b.classList.toggle('menu-open');
    else if (t.hasAttribute('data-search')) { var s = $('.search-bar'); s.classList.toggle('open'); var i = $('input[type=search]', s); if (i) i.focus(); }
    else if (t.hasAttribute('data-filters')) b.classList.add('filters-open');
    else if (t.hasAttribute('data-quick-add')) {
      e.preventDefault(); t.disabled = true; t.classList.add('busy');
      addToCart(t.getAttribute('data-quick-add'), 1).then(function () { t.classList.remove('busy'); t.classList.add('done'); setTimeout(function () { t.classList.remove('done'); t.disabled = false; }, 1400); })
        .catch(function (err) { toast(err.message); t.classList.remove('busy'); t.disabled = false; });
    } else if (t.hasAttribute('data-line-qty')) {
      e.preventDefault();
      post('/cart/change.js', { line: +t.getAttribute('data-line-qty'), quantity: +t.getAttribute('data-qty') })
        .then(function () { if (b.classList.contains('template-cart')) location.reload(); else return refreshCart(false); })
        .catch(function (err) { toast(err.message); });
    }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { b.classList.remove('cart-open', 'menu-open', 'filters-open'); hideAdded(); } });
  $$('[data-auto-submit]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });


  /* cart extras: countdown to a real deadline, delivery estimate, saved discount code */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    $$('[data-countdown]').forEach(function (el) {
      var left = +el.getAttribute('data-countdown') - Math.floor(Date.now() / 1000);
      if (left <= 0) { el.hidden = true; return; }
      var dd = Math.floor(left / 86400), hh = Math.floor(left % 86400 / 3600), mm = Math.floor(left % 3600 / 60), ss = left % 60;
      var out = $('[data-cd]', el); if (out) out.textContent = (dd ? dd + 'd ' : '') + pad(hh) + 'h ' + pad(mm) + 'm ' + pad(ss) + 's';
    });
  }
  function addWorkdays(n) { var x = new Date(); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0) n--; } return x; }
  function paintEta() {
    var f = function (x) { return x.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
    $$('[data-eta]').forEach(function (el) {
      var a = addWorkdays(+el.getAttribute('data-min')), z = addWorkdays(+el.getAttribute('data-max')), s = $('span', el);
      if (s) s.textContent = 'Get it between ' + f(a) + ' and ' + f(z);
    });
  }
  function paintDiscount() {
    var code = null; try { code = localStorage.getItem('liya-discount'); } catch (e) {}
    $$('[data-discount-note]').forEach(function (n) {
      if (code) { n.hidden = false; n.textContent = 'Code \u201c' + code + '\u201d is saved. It will be applied at checkout, where you will see your new total.'; }
      else { n.hidden = true; }
    });
  }
  function paintExtras() { tick(); paintEta(); paintDiscount(); }
  setInterval(tick, 1000);
  d.addEventListener('submit', function (e) {
    var f = e.target.closest ? e.target.closest('[data-discount-form]') : null; if (!f) return;
    e.preventDefault();
    var input = $('input[name=code]', f), code = (input.value || '').trim(), btn = $('button', f);
    if (!code) { toast('Enter a discount code'); return; }
    btn.disabled = true;
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { try { localStorage.setItem('liya-discount', code); } catch (x) {} paintDiscount(); toast('Discount code saved'); input.value = ''; })
      .catch(function () { toast('Could not save the code. Please try again.'); })
      .then(function () { btn.disabled = false; });
  });
  paintExtras();

  /* product page */
  var pdp = $('[data-product]');
  if (pdp) {
    var variants = JSON.parse($('[data-variants]').textContent);
    var form = $('[data-product-form]'), idInput = $('[data-variant-id]', form);
    var selected = $$('.opt', pdp).map(function (o) { return ($('.sizes .on', o) || {}).textContent; });
    var qtyInput = $('[data-qty-input]');
    var money = function (c) { return (c / 100).toLocaleString('en-IN', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR', maximumFractionDigits: 0 }); };

    function currentVariant() {
      if (!selected.length) return variants[0];
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
    }
    function paint(v) {
      var add = $('[data-add-btn]'), buy = $('[data-buy-now]'), st = $('[data-sticky-add]'), price = $('[data-price]');
      if (!v) { add.disabled = buy.disabled = st.disabled = true; add.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      add.disabled = buy.disabled = st.disabled = !v.available;
      add.textContent = v.available ? 'Add to bag' : 'Sold out';
      var p;
      if (v.compare_at_price > v.price) {
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        p = '<b class="sale">' + money(v.price) + '</b><s>' + money(v.compare_at_price) + '</s><span class="save-tag">Save ' + pct + '%</span>';
      } else { p = '<b>' + money(v.price) + '</b>'; }
      price.innerHTML = p + '<span class="tax-note">Inclusive of all taxes</span>';
      var stock = $('[data-stock]');
      if (stock) { stock.className = 'stock ' + (v.available ? 'in' : 'out'); stock.textContent = v.available ? 'In stock' : 'Currently sold out'; }
      $('[data-sticky-price]').textContent = money(v.price);
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      if (v.featured_media) {
        var idx = $$('.slide', pdp).findIndex(function (sl) { return sl.getAttribute('data-media-id') == v.featured_media.id; });
        if (idx > -1) showSlide(idx, true);
      }
    }
    $$('.opt', pdp).forEach(function (o, i) {
      o.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]'); if (!btn) return;
        $$('[data-value]', o).forEach(function (x) { x.classList.remove('on'); });
        btn.classList.add('on'); selected[i] = btn.getAttribute('data-value');
        $('.sel-name', o).textContent = selected[i];
        paint(currentVariant());
      });
    });
    $$('[data-q]', pdp).forEach(function (bt) {
      bt.addEventListener('click', function () { qtyInput.value = Math.max(1, (+qtyInput.value || 1) + (+bt.getAttribute('data-q'))); });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-add-btn]'), label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
      addToCart(idInput.value, qtyInput.value).then(function () { btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400); })
        .catch(function (err) { toast(err.message); btn.textContent = label; btn.disabled = false; });
    });
    $('[data-sticky-add]').addEventListener('click', function () { form.requestSubmit(); });
    $('[data-buy-now]').addEventListener('click', function () {
      post('/cart/add.js', { items: [{ id: +idInput.value, quantity: +qtyInput.value || 1 }] }).then(function () { location.href = '/checkout'; }).catch(function (err) { toast(err.message); });
    });

    /* gallery */
    var gal = $('[data-gallery]'), slides = $$('.slide', gal), thumbs = $$('[data-thumb]'), counter = $('[data-counter]'), cur = 0;
    function showSlide(i, scroll) {
      cur = i;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (scroll && gal.scrollWidth > gal.clientWidth) gal.scrollTo({ left: gal.clientWidth * i, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(+t.getAttribute('data-thumb')); }); });
    gal.addEventListener('scroll', function () {
      if (gal.scrollWidth <= gal.clientWidth) return;
      var i = Math.round(gal.scrollLeft / gal.clientWidth);
      if (i !== cur && i >= 0 && i < slides.length) showSlide(i);
    }, { passive: true });

    /* estimated delivery date (working days, Sundays skipped) */
    (function () {
      var el = $('[data-delivery]'); if (!el) return;
      function addDays(n) { var x = new Date(); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0) n--; } return x; }
      var f = function (x) { return x.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
      var a = addDays(+el.getAttribute('data-min')), z = addDays(+el.getAttribute('data-max'));
      el.textContent = 'Get it between ' + f(a) + ' and ' + f(z);
    })();

    /* image zoom lightbox */
    (function () {
      var lb = $('[data-lightbox]'); if (!lb) return;
      var img = $('[data-lb-img]', lb), count = $('[data-lb-count]', lb), idx = 0;
      var srcs = $$('.slide', gal).map(function (s) { return s.getAttribute('data-zoom'); });
      function show(i) { idx = (i + srcs.length) % srcs.length; img.src = srcs[idx]; count.textContent = (idx + 1) + ' / ' + srcs.length; }
      function open(i) { if (!srcs[i]) return; lb.hidden = false; b.classList.add('lb-open'); show(i); }
      function close() { lb.hidden = true; b.classList.remove('lb-open'); img.removeAttribute('src'); }
      slides.forEach(function (s, i) { s.addEventListener('click', function () { open(i); }); });
      $('[data-lb-close]', lb).addEventListener('click', close);
      $('[data-lb-prev]', lb).addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
      $('[data-lb-next]', lb).addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      d.addEventListener('keydown', function (e) { if (lb.hidden) return; if (e.key === 'Escape') close(); if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1); });
      var sx = null;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1)); sx = null; });
    })();

    /* sticky buy bar */
    var sticky = $('[data-sticky]'), anchor = $('[data-add-btn]');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0]; sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(anchor);
    }
  }
})();
